import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { companyInfo } from '../data/mock';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Hide tooltip after 5 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 7000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      '¡Hola! Me interesa obtener más información sobre sus servicios de construcción y reparación.'
    );
    const whatsappUrl = `https://wa.me/${companyInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-20 right-0 bg-white rounded-2xl shadow-2xl p-4 mb-2 max-w-xs animate-fade-in">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute top-2 right-2 text-slate-400 hover:text-slate-600"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="pr-4">
            <p className="font-bold text-slate-900 mb-1">¿Necesitas ayuda?</p>
            <p className="text-sm text-slate-600">
              Chatea con nosotros en WhatsApp para respuesta inmediata
            </p>
          </div>
          <div className="absolute bottom-0 right-8 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white transform translate-y-full" />
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="group relative bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all duration-300 animate-fade-in"
        aria-label="Contactar por WhatsApp"
      >
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75" />
        
        {/* Icon */}
        <div className="relative">
          <MessageCircle className="w-8 h-8" fill="currentColor" />
        </div>

        {/* Badge - Online indicator */}
        <div className="absolute top-0 right-0 w-4 h-4 bg-green-400 border-2 border-white rounded-full" />
      </button>

      {/* Desktop hover text */}
      <div className="hidden lg:block absolute bottom-6 right-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
          Chatea con nosotros
        </div>
      </div>
    </div>
  );
};

export default WhatsAppButton;
